import {
  CREATE_PRIME_OFFER,
  UPDATE_PRIME_OFFER,
  UNLOAD_PRIME_OFFER,
  PRIME_OFFER_FETCHED_SUCCESS,
  RESET_PRIME_OFFER,
} from '../constants/actionTypes';

const initialState = {
  offers: [],
  message: '',
  pager: {
    current: 1,
    pageSize: 15,
    total: 0,
  },
};

export default (state = initialState, action) => {
  switch (action.type) {
    case CREATE_PRIME_OFFER:
    case UPDATE_PRIME_OFFER:
      return {
        ...state,
        message: action.payload.msg,
      };

    case RESET_PRIME_OFFER:
      return {
        ...state,
        message: '',
      };

    case PRIME_OFFER_FETCHED_SUCCESS:
      return {
        ...state,
        offers: action.payload.offers.map((item) => {
          // eslint-disable-next-line no-underscore-dangle
          const newItem = { ...item, id: item.id };
          return newItem;
        }),
        pager: action.payload.pager,
      };

    case UNLOAD_PRIME_OFFER:
      return initialState;

    default:
      return state;
  }
};
